import React, { useState } from 'react';
import { MinusCircleIcon } from '../../../../static/icons/iconMinusCircle';
import { PlusCircleIcon } from '../../../../static/icons/iconPlusCircle';
import colors from '../../../../tailwind.colors';
import { Row } from '../row/Row';
import { Typography } from '../typography/Typography';
import { Stack } from '../stack/Stack';
import { cnMerge } from '../../../utils/utils';

const Accordion = ({
  title,
  description,
  children,
  className,
  titleClass,
  darkMode,
  titleVariant,
  descriptionVariant,
  justifyStart,
  iconColor,
  iconSize = 24,
  open = false,
}) => {
  const [isOpen, setIsOpen] = useState(open);

  return (
    <div className={cnMerge('border-b border-customGray-200', className)}>
      <Row
        className={`${
          justifyStart ? 'justify-start' : 'justify-between'
        } items-center ${description ? 'py-3' : 'py-4'} cursor-pointer`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Stack className="gap-0 max-w-[85%]">
          <Typography
            fontVariant={titleVariant ?? 'h8'}
            textAlign="left"
            className={cnMerge(
              `${
                darkMode ? '!text-white' : '!text-customGray-900'
              } whitespace-nowrap text-ellipsis overflow-hidden`,
              titleClass
            )}
          >
            {title}
          </Typography>
          <Typography
            fontVariant={descriptionVariant ?? 'xs'}
            textAlign="left"
            className={`leading-tight ${
              darkMode ? '!text-white' : '!text-customGray-900'
            } whitespace-nowrap text-ellipsis overflow-hidden`}
          >
            {description}
          </Typography>
        </Stack>
        {isOpen || open ? (
          <MinusCircleIcon
            color={iconColor ?? (darkMode ? 'white' : colors.customGray[900])}
            iconSize={iconSize}
          />
        ) : (
          <PlusCircleIcon
            color={iconColor ?? (darkMode ? 'white' : colors.customGray[900])}
            iconSize={iconSize}
          />
        )}
      </Row>
      <div
        className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
          isOpen || open ? '' : 'max-h-0'
        }`}
      >
        <Stack className="flex gap-0 pb-4">{children}</Stack>
      </div>
    </div>
  );
};

export default Accordion;
